import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { getRetailUsers } from '../../services/admin/users';

import usePermissions from '../../hooks/usePermission';

const permissionsMap = {
  canView: ['SYS_SUPERUSER'],
};

const RetailListForReport = ({ value, onChange, userTypesIds }) => {
  const [content, setContent] = useState([]);
  const { canView } = usePermissions(permissionsMap);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const idsToFetch = userTypesIds?.length > 0 ? userTypesIds : [null];

        const results = await Promise.all(
          idsToFetch.map((userTypeId) =>
            getRetailUsers({
              criterias: {
                deleted: false,
                page: 0,
                size: 10000,
                ...(userTypeId != null && { userTypeId }),
              },
            }),
          ),
        );

        setContent(results.map((res) => res.content).flat());
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    if (canView) {
      fetchData();
    }
  }, [userTypesIds, canView]);

  const handleChange = useCallback(
    (val) => {
      const selectedNames = content
        .filter((user) => val.includes(user.id))
        .map((user) => user.fullname);

      onChange(selectedNames.join(','));
    },
    [onChange, content],
  );

  const internalValue = useMemo(() => {
    return content
      .filter((user) =>
        value?.split(',').some((name) => name === user.fullname),
      )
      .map((user) => user.id);
  }, [value, content]);

  return (
    <Select
      mode="multiple"
      allowClear
      value={internalValue}
      onChange={handleChange}
      showSearch
      optionFilterProp="children"
    >
      {content &&
        content.map(({ id, fullname }) => (
          <Select.Option key={id} value={id}>
            {fullname}
          </Select.Option>
        ))}
    </Select>
  );
};

export default RetailListForReport;
